import { render, staticRenderFns } from "./customerFiles.vue?vue&type=template&id=515f3162&scoped=true"
import script from "./customerFiles.vue?vue&type=script&lang=js"
export * from "./customerFiles.vue?vue&type=script&lang=js"
import style0 from "./customerFiles.vue?vue&type=style&index=0&id=515f3162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515f3162",
  null
  
)

export default component.exports